
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiSwitchHorizontalOnLarge as ObiSwitchHorizontalOnLargeElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-switch-horizontal-on-large.js';
 
 
 

 
 export const ObiSwitchHorizontalOnLarge = createComponent({
   react: React,
   tagName: 'obi-switch-horizontal-on-large',
   elementClass: ObiSwitchHorizontalOnLargeElement,
   events: {
     
   }
  });
 
 